<template>
  <div class="content">
    <sub-title>카지노</sub-title>
    <div class="casinoslot_panel">
      <money-chip-change-comp></money-chip-change-comp>
      <div class="items">
        <div class="itm">
          <div class="pic" @click="openGame(HONOR_EVO_GAMEID,HONOR_EVO_VENDOR,3)">
            <img src="../../../assets/images/casino/c/01.png" alt="">
          </div>
        </div>
        <div class="itm">
            <div class="pic" @click="openGame(HONOR_DREAM_GAMEID,HONOR_DREAM_VENDOR,3)">
            <img src="../../../assets/images/casino/c/02.png" alt="">
          </div>
        </div>
        <div class="itm">
          <div class="pic" @click="openGame(HONOR_ASIAGAME_GAMEID,HONOR_ASIAGAME_VENDOR,3)">
            <img src="../../../assets/images/casino/c/03.png" alt="">
          </div>
        </div>
        <div class="itm">
          <div class="pic" @click="openGame(HONOR_PRAGMATIC_GAMEID,HONOR_PRAGMATIC_VENDOR,3)">
            <img src="../../../assets/images/casino/c/04.png" alt="">
          </div>
        </div>
        <div class="itm">
          <div class="pic" @click="openGame(HONOR_BOTA_GAMEID,HONOR_BOTA_VENDOR,3)">
            <img src="../../../assets/images/casino/c/05.png" alt="">
          </div>
        </div>
        <div class="itm">
          <div class="pic" @click="openGame(HONOR_SEXY_GAMEID,HONOR_SEXY_VENDOR,3)">
            <img src="../../../assets/images/casino/c/07.png" alt="">
          </div>
        </div>
        <div class="itm">
          <div class="pic" @click="openGame(HONOR_MICRO_GAMEID,HONOR_MICRO_VENDOR,3)">
            <img src="../../../assets/images/casino/c/08.png" alt="">
          </div>
        </div>
        <div class="itm">
          <div class="pic" @click="openGame(HONOR_SKYWIND_GAMEID,HONOR_SKYWIND_VENDOR,3)">
            <img src="../../../assets/images/casino/c/09.png" alt="">
          </div>
        </div>

        <div class="itm">
          <div class="pic"  @click="openGame(HONOR_DBLIVE_GAMEID,HONOR_DBLIVE_VENDOR,3)">
            <img src="../../../assets/images/casino/c/06.png" alt="">
          </div>
        </div>
        <div class="itm">
          <div class="pic" @click="openGame(HONOR_BETGAMES_GAMEID,HONOR_BETGAMES_VENDOR,3)">
            <img src="../../../assets/images/casino/c/10.png" alt="">
          </div>
        </div>
      </div>
    </div>

    <my-unchecked-message-comp></my-unchecked-message-comp>
  </div>

</template>


<script>

    import {RECEIVE_HIDE_LOADING, RECEIVE_SHOW_LOADING} from "@/store/mutation-types";
    import {casinoNextZoneMixin, checkLoginOnCreateMinxin, postionMixin} from "@/common/mixin";
    import SubTitle from "@/views/afront/zero/SubTitle.vue";
    import MoneyChipChangeComp from "@/views/afront/casino/MoneyChipChangeComp.vue";
    import {getCasinoMaintaining} from "@/network/casinoHonorRequest";
    import MyUncheckedMessageComp from "@/views/afront/notice/MyUncheckedMessageComp.vue";
    export default {
      name: "CasinoHonor",
      mixins: [postionMixin,casinoNextZoneMixin,checkLoginOnCreateMinxin],
      components: {
        MyUncheckedMessageComp,
        MoneyChipChangeComp,
        SubTitle

      },
      data() {
        return {
          position: "카지노",
        }
      },
      methods: {

      },
      created() {
        if (this.$store.state.isLogin) {
          getCasinoMaintaining().then(res => {
            if (res.data.success) {
              if (!res.data.data) {
                this.$swal({
                  title: '카지노 점검중입니다',
                  type: 'error',
                  confirmButtonText: '확인',
                  showCancelButton: false,
                  showConfirmButton: true
                })
              }
            } else {
              this.$swal({
                title: res.data.msg,
                type: 'error',
                showCancelButton: false,
                showConfirmButton: true
              })
            }

          })
        }
      },
    }
</script>

<style scoped>
    @import url("../../../assets/css/front/afrontcasinoslot.css");
</style>